import * as React from 'react';
import { useEffect } from 'react';

import { RewardsIcon } from '@sandtech-hub-monorepo/ui-kit-site';
import { GetLegacyPointsUserDocument } from '@sandtech-hub-monorepo/ehub-client';
import { useGetMaybeViewer } from '@sandtech-hub-monorepo/ui-auth-kit';
import { useLazyQuery } from '@apollo/client';
import { NavigationMenuItem } from '@sandtech-hub-monorepo/ui-kit';
import { LEGACY_PTS_MENU_ITEM_VALUE } from '../utils';

export const LegacyPoints = ({
  className,
  rewardsLink,
}: {
  className?: string;
  rewardsLink: string;
}) => {
  const { viewer } = useGetMaybeViewer();

  const [getLegacyPointsUser, { data: legacyPointsUser }] = useLazyQuery(
    GetLegacyPointsUserDocument,
    {}
  );

  useEffect(() => {
    if (viewer?.sandId) {
      getLegacyPointsUser({
        variables: {
          where: {
            sandId: viewer.sandId,
          },
        },
      });
    }
  }, [viewer, getLegacyPointsUser]);

  return (
    <NavigationMenuItem
      className={className}
      value={LEGACY_PTS_MENU_ITEM_VALUE}
      onClick={() => {
        //TODO @mike
        window.location.replace(rewardsLink);
      }}
    >
      <div className="flex gap-1 border border-border rounded-full py-1 px-2 items-center bg-card hover:bg-accent-foreground">
        <RewardsIcon />
        <span className="font-bold text-sm text-card-foreground">
          {legacyPointsUser?.lpUser?.balance || 0}
        </span>
        <span className="hidden md:inline font-bold text-sm text-card-foreground">
          points
        </span>
      </div>
    </NavigationMenuItem>
  );
};
